const pathPlaceholder = {
  USER_ID: 'userId',
  CHANNEL_ID: 'channelId',
};

const storagePaths = {
  USER: 'user',
  CHAT: 'chat',
};

storagePaths.USER_COLLECTION = `${storagePaths.USER}/{${pathPlaceholder.USER_ID}}`;
storagePaths.CHAT_COLLECTION = `${storagePaths.CHAT}/{${pathPlaceholder.CHANNEL_ID}}`;

export {
  storagePaths,
  pathPlaceholder,
};
